import { render, staticRenderFns } from "./daily-winner.vue?vue&type=template&id=00ffb2cc&"
import script from "./daily-winner.vue?vue&type=script&lang=js&"
export * from "./daily-winner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports